module.exports = __webpack_public_path__ + "static/media/110a.96161a51.svg";